import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function PlanCard({ plan, features, isYearly }) {
  
  const includedFeatureIds = plan.features || [];
  
  // Ensure features is always an array
  const featuresArray = Array.isArray(features) ? features : [];
  
  const freeLabel = plan.free_first > 0
    ? `Gratuit în ${plan.free_first === 1 ? 'prima lună' : `primele ${plan.free_first} luni`}`
    : null;

  const professionalsLabel = plan.max_employees === -1
    ? 'Profesioniști activi nelimitați'
    : plan.max_employees === 1
      ? '1 profesionist activ'
      : `Până la ${plan.max_employees} profesioniști activi`;

  return (
    <div className="col-md-3 lumo-plan">
      <div className={`pannel_block d-flex flex-column justify-content-around align-items-center ${plan.popular ? 'highlited_block' : ''}`} data-aos="fade-up" data-aos-duration={1500}>
        <div className='plan-metadata'>
          <div className="heading">
            <h3>{plan.name}</h3>
            <span className='plan-description'>{plan.description}</span>
            {plan.popular && <span className="offer">Popular</span>}
          </div>
          <div className="pricing">
            <h3>€{isYearly ? plan.yearly_price : plan.price} <span>/lună</span></h3>
          </div>
        </div>
        <ul className="features">
          {freeLabel && (
            <li>
              <span className="icon"><i className="icofont-check-circled" /></span>
              <p>{freeLabel}</p>
            </li>
          )}
          <li><span className="icon"><i className="icofont-check-circled" /></span><p>{professionalsLabel}</p></li>
            {[
              // Included features first
              ...featuresArray.filter(f => includedFeatureIds.includes(f.id)),
              // Then the rest
              ...featuresArray.filter(f => !includedFeatureIds.includes(f.id))
            ].map((f) => {
              const included = includedFeatureIds.includes(f.id);

              return (
                <li key={f.id}>
                  <span className="icon">
                    <i className={included ? "icofont-check-circled" : "icofont-close-circled"} />
                  </span>

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-${f.id}`}>{f.description}</Tooltip>}
                  >
                    <p
                      style={{
                        textDecorationLine: 'underline',
                        textDecorationStyle: 'dotted',
                        textDecorationThickness: '2px',
                        textUnderlineOffset: '5px',
                        textDecorationColor: '#999',
                        cursor: 'pointer',
                        display: 'inline-block',
                        margin: 0,
                      }}
                    >
                      {f.name}
                    </p>
                  </OverlayTrigger>
                </li>
              );
            })}
        </ul>
        <div className={`btn_block ${plan.popular ? 'white_btn' : ''}`}>
          <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">Alege pachet</Link>
          <div className="btn_bottom border-color-lumo-orange" />
        </div>
      </div>
    </div>
  );
}

export default PlanCard;
